import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Panel } from 'primeng/panel';
import { HisCoreSharedModule } from '../../../../core/his-core-shared.module';
import { Result } from '../bi-analysis-table/flat-table/model/result';
import { HisDisplayCodeComponent } from '../../../../display/component/his-display-code/his-display-code.component';

@Component( {
    standalone: true,
    selector: 'his-bi-generated-sql',
    templateUrl: './generated-sql.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [Panel, HisCoreSharedModule, HisDisplayCodeComponent]
} )

export class BiAnalysisGeneratedSqlComponent {

    noAggregatesSQL: string = '';
    totalsColumnSQL: string = '';

    @Input()
    set result( value: Result | undefined ) {
        this.noAggregatesSQL = this.formatSql( this.getSQL( value, 'noAggregatesSQL' ) );
        this.totalsColumnSQL = this.formatSql( this.getSQL( value, 'totalsColumnSQL' ) );
    }

    getSQL( result: Result, key: string ): string {
        return result?.info?.sqlStatements.find( s => s.label === key )?.value ?? '';
    }

    private formatSql( sql: string ): string {
        return sql
            .trim()
            .replace( /\s+/g, ' ' )
            .replace( /\bselect\b/gi, 'SELECT' )
            .replace(
                /(\bAS\s+(?:"[^"]+"|[a-zA-Z_][a-zA-Z0-9_]*))\s*,\s*/gi,
                '$1,\n       '
            )
            .replace( /\bfrom\b/gi, '\nFROM' )
            .replace(
                /\b(left|right|inner|outer|cross)?\s*join\b/gi,
                '\n$1 JOIN'
            )
            .replace( /\bwhere\b/gi, '\nWHERE' )
            .replace( /\bgroup\s+by\b/gi, '\nGROUP BY' )
            .replace( /\border\s+by\b/gi, '\nORDER BY' )
            .replace( /\bhaving\b/gi, '\nHAVING' )
            .replace( /\band\b/gi, '\n  AND' )
            .replace( /\bor\b/gi, '\n  OR' );
    }

}
